import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { UserList } from 'models';
import { Col, InfinityLoading, Row, Skeleton, Space, Text } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButton } from 'features/chat';
import { AvatarLink } from '../avatar-link';
import { UserNameLink } from '../user-name-link';
import { UserPopover } from '../user-popover';

type P = {
  queryData: {
    fetchNextPage: () => void;
    hasNextPage?: boolean;
    isFetching: boolean;
    isLoading: boolean;
  };
  users?: UserList[];
};

const UsersList = ({ queryData: { fetchNextPage, hasNextPage, isFetching, isLoading }, users }: P) => {
  const { railsUserData: viewer } = useUser();
  const getUserNameWithFallback = useGetUserNameWithFallback();

  return (
    <>
      {isLoading || !users ? (
        <Skeleton active paragraph={{ rows: 14 }} title={false} />
      ) : (
        <Space block orientation="vertical" size="middle">
          {users.map((user) => (
            <Row align="middle" gutter={['ms', 'xs']} justify="space-between" key={user.id}>
              <Col>
                <UserPopover user={user}>
                  <AvatarLink avatar={{ src: user.profilePhoto }} userId={user.id}>
                    {getUserNameWithFallback(user)}
                  </AvatarLink>
                </UserPopover>
              </Col>
              <Col flex="1 1 0">
                <Row gutter="xxs">
                  <Col>
                    <UserPopover user={user}>
                      <UserNameLink type="text" userId={user.id}>
                        {getUserNameWithFallback(user)}
                      </UserNameLink>
                    </UserPopover>
                  </Col>
                  {user.id === viewer.id ? (
                    <Col>
                      <Text type="title" weight="medium">
                        (You)
                      </Text>
                    </Col>
                  ) : null}
                </Row>
              </Col>
              <Col>
                <IconDirectMessageButton legacyUserId={user.id} />
              </Col>
            </Row>
          ))}

          <InfinityLoading
            hasMoreData={hasNextPage}
            isLoading={isFetching}
            onEnter={fetchNextPage}
            spinnerSize="small"
          />
        </Space>
      )}
    </>
  );
};

export default UsersList;
